import { Fab, styled } from '@mui/material'

export const FabStyled = styled(Fab)`
  min-height: 30px;
  min-width: 30px;
  height: 30px;
  width: 30px;
`
